
import {LOGGED_IN} from "../../constants/"
export const SaveLoginInfo = (payload) => {
    return {
        type: LOGGED_IN,
        payload
    }
}
